import type { PhotoSlot } from '../capture/photoSlotModel';
import type { useSlotCapture } from '../capture/useSlotCapture';
import { RoomTile } from './RoomTile';

/** Alle Räume auf einen Blick, zwei Spalten am Handy; ohne Raumliste kein Raster. */
export function RoomGrid({
  taskId,
  slots,
  capture,
  captureLocked,
  retakeLocked,
  willComplete,
  willBeIssue,
}: {
  taskId: string;
  slots: PhotoSlot[];
  capture: ReturnType<typeof useSlotCapture>;
  captureLocked: boolean;
  retakeLocked: boolean;
  willComplete: boolean;
  willBeIssue: boolean;
}) {
  if (slots.length === 0) return null;
  const retaking = capture.retakeSlot.isPending ? capture.retakeSlot.variables : undefined;
  return (
    <section aria-label="Räume" className="@container">
      <ul className="@lg:grid-cols-3 grid grid-cols-2 gap-2.5">
        {slots.map((slot) => (
          <li key={slot.item.id}>
            <RoomTile
              taskId={taskId}
              slot={slot}
              captureLocked={captureLocked}
              retakeLocked={retakeLocked}
              busy={
                slot.photo ? retaking === slot.photo.id : capture.uploadingItemIds.has(slot.item.id)
              }
              failed={!slot.photo && capture.uploadErrorItemIds.has(slot.item.id)}
              onCapture={(file) =>
                capture.uploadToSlot.mutate({
                  itemId: slot.item.id,
                  file,
                  willComplete,
                  willBeIssue,
                })
              }
              onRetake={(photoId) => capture.retakeSlot.mutate(photoId)}
            />
          </li>
        ))}
      </ul>
    </section>
  );
}
